import { createFileRoute, Link } from "@tanstack/react-router";

import { Section } from "@roqua/components/sections";

import { Logo } from "@/components/RoquaLogo";

export const Route = createFileRoute("/registration/$slug/registered")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div>
      <header className="z-10 flex h-16 w-full flex-wrap  items-center justify-between bg-neutral-800 px-4 py-2 text-xs text-white">
        <div className="mx-auto text-white">
          <Link to="/portal">
            <Logo />
          </Link>
        </div>
      </header>
      <Section variant="content">
        <main className="mx-auto max-w-xl py-12">
          <p className="mb-4 text-xl font-bold">Bedankt voor uw aanmelding!</p>
          <p className="mb-4">
            Uw inschrijving is bijna compleet. Er is nog één stap nodig om uw deelname te
            bevestigen. Ga naar uw e-mailinbox en klik op de bevestigingslink die we zojuist naar u
            hebben gestuurd. Zodra u dit hebt gedaan, is uw inschrijving definitief.
          </p>
          <p>Hebt u de e-mail niet ontvangen? Controleer dan uw spamfolder.</p>
        </main>
      </Section>
    </div>
  );
}
